import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import {
  ConsoleLayout,
  DefaultNotFound,
  TooltipProvider,
} from '~in-app/components'
import { auth$, route$ } from '~in-app/legend-state'
import { router } from '~in-app/router'

export const Route = createFileRoute('/console')({
  beforeLoad: (value) => {
    if (!auth$.jwt.get()) {
      route$.registerPage(value.location.pathname)
      route$.tracePath(value.location.pathname)
      return redirect({ to: '/sign-in' })
    }

    value.matches.at(-1)?.staticData.privileges.length

    if (!value.preload) {
      if (value.matches.at(-1)?.staticData.privileges.length! > 0) {
        const privilegeValue = auth$.privileges.get()
        const privileges = value.matches.at(-1)?.staticData.privileges || []
        const hasPermission = privileges.some(privilege =>
          privilegeValue?.has(privilege),
        )
        const privilegesValues = privileges.reduce((map, privilege) => {
          const value = privilegeValue?.get(privilege)
          if (value) {
            return map.set(privilege, value)
          }
          return map
        }, new Map())

        if (!hasPermission) {
          router.navigate({ to: '/console/no-permission' })
        }
      }
    }
  },
  component: ConsoleLayoutRoute,
  notFoundComponent: () => DefaultNotFound(),
  staticData: {
    privileges: [],
  },
})

function ConsoleLayoutRoute() {
  return (
    <TooltipProvider delayDuration={350}>
      <ConsoleLayout.Provider>
        <div className="flex h-screen">
          <ConsoleLayout.Sidebar.Sidebar />

          <div className="flex flex-1 flex-col overflow-y-auto">
            <ConsoleLayout.Header />

            <div className="grow p-6">
              <Outlet />
            </div>
          </div>
        </div>
      </ConsoleLayout.Provider>
    </TooltipProvider>
  )
}
